<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: 'i-lucide-activity',
  },
  title: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'slate',
    validator: v =>
      [
        'slate',
        'blue',
        'green',
        'amber',
        'red',
        'purple',
        'pink',
        'violet',
        'cyan',
        'teal',
      ].includes(v),
  },
});

const iconColorClass = computed(() => {
  const colorMap = {
    slate: 'text-n-slate-10',
    blue: 'text-n-blue-10',
    green: 'text-n-teal-10',
    amber: 'text-n-amber-10',
    red: 'text-n-ruby-10',
    purple: 'text-n-purple-10',
    pink: 'text-n-pink-10',
    violet: 'text-n-violet-10',
    cyan: 'text-n-cyan-10',
    teal: 'text-n-teal-10',
  };
  return colorMap[props.color] || 'text-n-slate-10';
});

const valueColorClass = computed(() => {
  const colorMap = {
    slate: 'text-n-slate-12',
    blue: 'text-n-blue-11',
    green: 'text-n-teal-11',
    amber: 'text-n-amber-11',
    red: 'text-n-ruby-11',
    purple: 'text-n-purple-11',
    pink: 'text-n-pink-11',
    violet: 'text-n-violet-11',
    cyan: 'text-n-cyan-11',
    teal: 'text-n-teal-11',
  };
  return colorMap[props.color] || 'text-n-slate-12';
});
</script>

<template>
  <div class="flex flex-col rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <div class="flex items-center gap-2 mb-2">
      <span :class="[icon, iconColorClass]" class="text-base" />
      <span class="text-sm font-medium text-n-slate-11">{{ title }}</span>
    </div>
    <div :class="valueColorClass" class="text-2xl font-bold">{{ value }}</div>
    <div v-if="subtitle" class="text-xs text-n-slate-10 mt-1">
      {{ subtitle }}
    </div>
  </div>
</template>
